module.exports = __webpack_public_path__ + "img/uj_07.1fec63a3.jpg";